/**
 * Cloudflare Turnstile (invisible) – getToken for search/offers endpoints.
 * @see https://developers.cloudflare.com/turnstile/get-started/client-side-rendering/
 */

const TURNSTILE_SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
const CONTAINER_ID = 'cf-turnstile-offers';

let scriptLoadPromise = null;
let widgetId = null;
let currentResolve = null;
let currentReject = null;

function getSitekey() {
    const el = document.getElementById(CONTAINER_ID);
    return (el && el.getAttribute('data-sitekey')) || '';
}

function loadScript() {
    if (window.turnstile) {
        return Promise.resolve();
    }
    if (scriptLoadPromise) {
        return scriptLoadPromise;
    }
    scriptLoadPromise = new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = TURNSTILE_SCRIPT_URL;
        s.async = true;
        s.defer = true;
        s.onload = () => resolve();
        s.onerror = () => reject(new Error('Turnstile script failed to load'));
        (document.head || document.documentElement).appendChild(s);
    });
    return scriptLoadPromise;
}

function ensureWidget(sitekey) {
    if (widgetId !== null && widgetId !== undefined) {
        return;
    }
    const container = document.getElementById(CONTAINER_ID);
    if (!container) {
        throw new Error('Turnstile container #cf-turnstile-offers not found');
    }
    widgetId = window.turnstile.render(container, {
        sitekey,
        size: 'invisible',
        callback: (token) => {
            const r = currentResolve;
            currentResolve = null;
            currentReject = null;
            if (r) {
                r(token);
            }
        },
        'expired-callback': () => {
            const r = currentReject;
            currentResolve = null;
            currentReject = null;
            if (r) {
                r(new Error('Turnstile token expired'));
            }
        },
    });
}

/**
 * Returns a Promise that resolves with a Turnstile token for the invisible widget.
 * Rejects if sitekey is empty, container missing, or the challenge fails.
 *
 * @returns {Promise<string>}
 */
export function getTurnstileToken() {
    const sitekey = getSitekey();
    if (!sitekey) {
        return Promise.reject(new Error('Turnstile sitekey not configured'));
    }

    return loadScript().then(() => {
        ensureWidget(sitekey);
        return new Promise((resolve, reject) => {
            currentResolve = resolve;
            currentReject = reject;
            try {
                window.turnstile.reset(widgetId);
                window.turnstile.execute(widgetId);
            } catch (e) {
                currentResolve = null;
                currentReject = null;
                reject(e);
            }
        });
    });
}
